export const companies_details = [
  {
    key: "1",
    CompanyName: "NovaWaveLLC",
    Email: "robertson@gmail.com",
    AccountURL: "nw.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "25 Sep 2023",
    Image: "company-icon-01.svg",
    stars: "fa fa-star filled",
    Status: "Active",
  },
  {
    key: "2",
    CompanyName: "BlueSky Industries",
    Email: "sharon@example.com",
    AccountURL: "bsi.example.com",
    Plan: "Basic (Yearly)",
    CreatedDate: "29 Sep 2023",
    Image: "company-icon-02.svg",
    stars: "fa fa-star filled",
    Status: "Inctive",
  },
  {
    key: "3",
    CompanyName: "Silver Hawk",
    Email: "vaughan12@gmail.com",
    AccountURL: "sh.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "04 Oct 2023",
    Image: "company-icon-03.svg",
    stars: "fa fa-star filled",
    Status: "Active",
  },
  {
    key: "4",
    CompanyName: "Summit  Peak",
    Email: "jessica13@gmail.com",
    AccountURL: "sp.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "04 Oct 2023",
    Image: "company-icon-04.svg",
    stars: "fa fa-star filled",
    Status: "Active",
  },
  {
    key: "5",
    CompanyName: "RiverStone Ventur",
    Email: "carolTho3@gmail.com",
    AccountURL: "rsv.example.com",
    Plan: "Enterprise (Monthly)",
    CreatedDate: "27 Oct 2023",
    Image: "company-icon-05.svg",
    stars: "fa fa-star filled",
    Status: "Active",
  },
  {
    key: "6",
    CompanyName: "Bright Bridge Grp",
    Email: "dawnmercha@gmail.com",
    AccountURL: "bbg.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "28 Oct 2023",
    Image: "company-icon-06.svg",
    stars: "fa fa-star filled",
    Status: "Active",
  },
  {
    key: "7",
    CompanyName: "CoastalStar Co.",
    Email: "rachel@gmail.com",
    AccountURL: "csc.example.com",
    Plan: "Enterprise (Yearly)",
    CreatedDate: "29 Oct 2023",
    Image: "company-icon-07.svg",
    stars: "fa fa-star filled",
    Status: "Active",
  },
  {
    key: "8",
    CompanyName: "HarborView",
    Email: "jonelle@gmail.com",
    AccountURL: "hv.example.com",
    Plan: "Basic (Monthly)",
    CreatedDate: "30 Oct 2023",
    Image: "company-icon-08.svg",
    stars: "fa fa-star filled",
    Status: "Inactive",
  },
  {
    key: "9",
    CompanyName: "Golden Gate Ltd",
    Email: "jonathan@gmail.com",
    AccountURL: "ggl.example.com",
    Plan: "Basic (Yearly)",
    CreatedDate: "11 Dec 2023",
    Image: "company-icon-09.svg",
    stars: "fa fa-star filled",
    Status: "Active",
  },
  {
    key: "10",
    CompanyName: "Redwood Inc",
    Email: "brook@gmail.com",
    AccountURL: "ri.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "15 Dec 2023",
    Image: "company-icon-10.svg",
    stars: "fa fa-star filled",
    Status: "Active",
  },
];
